<template>
    <div id="tour-eclass-page" class="flex flex-1 space-x-2 ">

      <DashboardHeaderTab
        :title="'E-Class'"
        :tabs="tabs"
        :activeTab="activeTab"
        :setActiveTab="setActiveTab"
        :toggleSidebar="toggleSidebar"
      />

    </div>
</template>

<script setup lang="ts">
import DashboardHeaderTab from '@/components/DashBoard/common/DashboardHeaderTab.vue';
import { useTabs } from '@/composables/useTabs';
import SubjectResources from '@/components/DashBoard/E-Class/SubjectResources/SubjectResources.vue';
import UploadNewMaterial from '@/components/DashBoard/E-Class/UploadNewMaterial/UploadNewMaterial.vue';
import CreateClass from '@/components/DashBoard/E-Class/CreateClass/CreateClass.vue';
import { can, AppPermissions } from '@/utils/permissions';
import { useUserStore } from '@/store/userStore';

const toggleSidebar = inject<() => void>('toggleSidebar', () => {});
const userStore = useUserStore();

const tabs = computed(() => {
  const user = userStore.currentUser;
  const items: Array<{ name: string; component: Component; query: string }> = [];

  items.push({ name: 'Subject Resources', component: markRaw(SubjectResources), query: '' });

  if (can(user, AppPermissions.EducationalResources.Actions.Create, AppPermissions.EducationalResources.Resource)) {
    items.push({ name: 'Upload new material', component: markRaw(UploadNewMaterial), query: 'upload' });
  }

  if (can(user, AppPermissions.EducationalResources.Actions.Create, AppPermissions.EducationalResources.Resource)) {
    items.push({ name: 'Create Class', component: markRaw(CreateClass), query: 'create' });
  }

  return items;
});

const { activeTab, setActiveTab } = useTabs(tabs);

</script>

<style>

</style>
